export const sortAlphabetically = (a: any, b: any, value: string) => {
  const nameA = a[value].toUpperCase()
  const nameB = b[value].toUpperCase()

  if (nameA < nameB) return -1
  if (nameA > nameB) return 1

  return 0
}

export const sortNumerically = (a: any, b: any, value?: string) => {
  const nameA = value ? a[value] : a
  const nameB = value ? b[value] : b

  if (nameA < nameB) return -1
  if (nameA > nameB) return 1

  return 0
}
